import React, { useState, useEffect } from 'react';
import { FlexContainer } from '@/components/containers/FlexContainer/FlexContainer';
import { publicAsset } from '@/config/appPaths';
import { scrollToRegistration, scrollToSection } from '@/utils/scrollToSection';
import '@fortawesome/fontawesome-free/css/all.min.css';
import '../PersonalizedHeaderStyles.scss';

const Header = () => {
  const [menuOpen, setMenuOpen] = useState(false);

  const closeMenu = () => setMenuOpen(false);

  const goToHome = () => {
    closeMenu();
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  useEffect(() => {
    document.body.style.overflow = menuOpen ? 'hidden' : '';
    return () => {
      document.body.style.overflow = '';
    };
  }, [menuOpen]);

  const [isDesktopNav, setIsDesktopNav] = useState(false);

  useEffect(() => {
    const mediaQuery = window.matchMedia('(min-width: 1024px)');
    const syncDesktopNav = () => setIsDesktopNav(mediaQuery.matches);

    syncDesktopNav();
    mediaQuery.addEventListener('change', syncDesktopNav);

    return () => mediaQuery.removeEventListener('change', syncDesktopNav);
  }, []);

  const navbarLogoWhite = publicAsset('/basc/logo-basc-white.png');

  const navLinks = [
    { title: 'Inicio', onClick: goToHome },
    { title: 'Programa', onClick: () => { closeMenu(); scrollToSection('programa'); } },
    { title: 'Contenido', onClick: () => { closeMenu(); scrollToSection('contenido'); } },
    { title: 'Inversión', onClick: () => { closeMenu(); scrollToSection('modalidades'); } },
    { title: 'Preguntas frecuentes', onClick: () => { closeMenu(); scrollToSection('faq'); } },
    {
      title: 'Inscribirme',
      isCta: true,
      onClick: () => {
        closeMenu();
        scrollToRegistration();
      },
    },
  ];

  return (
    <FlexContainer className="flex-column myMainNavBar width100">
      <header className="header-nav">
        <div className="header-nav__inner">
          <div className="header-nav__bar">
            <button
              type="button"
              className="header-nav__logo-btn"
              onClick={goToHome}
              aria-label="BASC Perú - Inicio"
            >
              <img src={navbarLogoWhite} alt="BASC Perú" className="header-nav__logo" />
            </button>
            <button
              type="button"
              className="header-nav__toggle"
              aria-expanded={menuOpen}
              aria-label={menuOpen ? 'Cerrar menú' : 'Abrir menú'}
              onClick={() => setMenuOpen((open) => !open)}
            >
              <i className={`fa-solid ${menuOpen ? 'fa-xmark' : 'fa-bars'}`} aria-hidden="true" />
            </button>
          </div>

          {menuOpen && (
            <button
              type="button"
              className="header-nav__backdrop"
              aria-label="Cerrar menú"
              onClick={closeMenu}
            />
          )}

          <nav
            className={`header-nav__menu ${menuOpen ? 'header-nav__menu--open' : ''}`}
            aria-hidden={!menuOpen && !isDesktopNav}
          >
            {navLinks.map((link) => (
              <button
                key={link.title}
                type="button"
                className={
                  link.isCta ? 'header-nav__link header-nav__link--cta' : 'header-nav__link'
                }
                onClick={link.onClick}
              >
                {link.title}
              </button>
            ))}
          </nav>
        </div>
      </header>
    </FlexContainer>
  );
};

export default Header;
